module.exports = __webpack_public_path__ + "static/media/AIR_AMS_TYPE86_TEMPLATE.da51266a.csv";